import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'home'},

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'home'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },
  
    
    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'example', loadChildren: () => import('app/modules/admin/example/example.routes')},
            {path: 'home', loadChildren: () => import('app/modules/admin/home/home.routes')},

            {path: 'report-customers', loadChildren: () => import('app/modules/admin/report/reportCustomer/report-customer.routes')},
             {path: 'report-customers/detail/:code', loadChildren: () => import('app/modules/admin/report/reportCustomer/detail/report-customer-detail.routes')},

            //{path: 'report-suppliers', loadChildren: () => import('app/modules/admin/report/reportSupplier/report-supplier.routes')},
            //{path: 'report-suppliers/report-supplier-detail', loadChildren: () => import('app/modules/admin/report/reportSupplier/detail/report-supplier-detail.routes')},

            //{path: 'report-sales', loadChildren: () => import('app/modules/admin/report/reportSales/report-sales.routes')},
            //{path: 'report-sales/report-sale-detail', loadChildren: () => import('app/modules/admin/report/reportSales/detail/report-sales-detail.routes')},

            //{path: 'report-products', loadChildren: () => import('app/modules/admin/report/reportProduct/report-product.routes')},
            //{path: 'report-products/report-product-detail', loadChildren: () => import('app/modules/admin/report/reportProduct/detail/report-product-detail.routes')},

            //{path: 'report-agents', loadChildren: () => import('app/modules/admin/report/reportAgent/report-agent.routes')},
            //{path: 'report-agents/report-agent-detail', loadChildren: () => import('app/modules/admin/report/reportAgent/detail/report-agent-detail.routes')},

            //{path: 'report-contracts', loadChildren: () => import('app/modules/admin/report/reportContract/report-contract.routes')},
            //{path: 'report-contracts/report-contract-detail', loadChildren: () => import('app/modules/admin/report/reportContract/detail/report-contract-detail.routes')},

            {path: 'users', loadChildren: () => import('app/modules/admin/user/user.routes')},

            {path: 'agents', loadChildren: () => import('app/modules/admin/agent/agent.routes')},
            {path: 'agents/agent-assignment/:code', loadChildren: () => import('app/modules/admin/agent/assignment/agent-assignment.routes')},

            {path: 'customers', loadChildren: () => import('app/modules/admin/customer/customer.routes')},
             {path: 'customer-destination', loadChildren: () => import('app/modules/admin/customer-destination/customer-destination.routes')},
            {path: 'suppliers', loadChildren: () => import('app/modules/admin/supplier/supplier.routes')},
            {path: 'products', loadChildren: () => import('app/modules/admin/product/product.routes')},
            {path: 'companies', loadChildren: () => import('app/modules/admin/company/company.routes')},            
            {path: 'categories', loadChildren: () => import('app/modules/admin/category/category.routes')},

            {path: 'jobs', loadChildren: () => import('app/modules/admin/job/job.routes')},
            {path: 'transactions', loadChildren: () => import('app/modules/admin/transaction/transaction.routes')},

            {path: 'contracts', loadChildren: () => import('app/modules/admin/contract/contract.routes')},
            {path: 'contracts/transaction/:code', loadChildren: () => import('app/modules/admin/contract/transaction/contract-transaction.routes')},
            {path: 'contract-competitor', loadChildren: () => import('app/modules/admin/contract-competitor/contract-competitor.routes')},
        ]
    }
];
